import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import { createContext, useContext, useEffect, useMemo, useRef } from "react";
import { PromiseQueue } from "~/classes/PromiseQueue";
import { SearchTranscriptFetchQueueProvider } from "~/providers/SearchTranscriptFetchQueueProvider";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const defaultValue = {
    fetchQueue: {
        current: undefined
    }
};
export const ClipTranscriptFetchQueueContext = /*#__PURE__*/ createContext(defaultValue);
export const ClipTranscriptFetchQueueProvider = (param)=>{
    let { children } = param;
    const fetchQueue = useRef();
    useEffect(()=>{
        fetchQueue.current = new PromiseQueue();
        return ()=>{
            var _fetchQueue_current;
            (_fetchQueue_current = fetchQueue.current) === null || _fetchQueue_current === void 0 ? void 0 : _fetchQueue_current.cancelAll();
        };
    }, []);
    const value = useMemo(()=>({
            fetchQueue
        }), [
        fetchQueue
    ]);
    return /*#__PURE__*/ _jsx(ClipTranscriptFetchQueueContext.Provider, {
        value: value,
        children: /*#__PURE__*/ _jsx(SearchTranscriptFetchQueueProvider, {
            children: children
        })
    });
};
export const useClipTranscriptFetchQueueContext = ()=>{
    const context = useContext(ClipTranscriptFetchQueueContext);
    if (context === defaultValue) {
        const error = "ClipTranscriptFetchQueueContext used outside of ClipTranscriptFetchQueueProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
